// extracted by mini-css-extract-plugin
export default {"slideActions":"styles_slideActions__sTn2U","slideActionsBox":"styles_slideActionsBox__yYqM6","slideActionsLabel":"styles_slideActionsLabel__C0Bl2"};